import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapIssueList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - Issue Transactions"
      opTypes={["issue"]}
    />
  );
}
